import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './Footer';
import './LandingPage.css';
import { useState, useEffect } from 'react';
import UnlockToolImg from '../Images/Unlocktool.png';
import PandoraToolImg from '../Images/Pandora.png';
import Cm2PortSharingImg from '../Images/Cm2.png';
import TfmImg from '../Images/Tfm.png';
import HydraImg from '../Images/Hydra.png';
import CheatahImg from '../Images/Cheatah.png';
import TigerGuardImg from '../Images/Tiger.png';
import MdmFixToolImg from '../Images/Mdmfix.png';
import DftImg from '../Images/Dft.png';
import TsmImg from '../Images/TSM.png';
import AmtImg from '../Images/amt.png';
import Anonyshu from '../Images/anonyshu.png';
import TR from '../Images/tr.png';
import Awt from '../Images/awt.png';
import GFS from '../Images/GFS.png';
import EFT from '../Images/EFT.png';
import THREE60 from '../Images/360.png';
import vivo from '../Images/vivo.png';

// Reseller Logos
import DevRovinceLogo from '../Images/logo.png';
import RantechLogo from '../Images/rantech.png';
import Kingsley0xpLogo from '../Images/KINGSLEY0XP.png';
import BrightPhoneLogo from '../Images/logo.png';
import FalconGsmLogo from '../Images/falcon.png';
import JonaTekLogo from '../Images/jona.png';
import LegendTchLogo from '../Images/logo.png';
import WizzotechLogo from '../Images/logo.png';
import KazuriTechLogo from '../Images/logo.png';
import JudeGadgetsLogo from '../Images/logo.png';
import ShamboSoftLogo from '../Images/logo.png';
import PhonetechMasterLogo from '../Images/logo.png';
import MrgriffLogo from '../Images/griff.png';
import WillystechubLogo from '../Images/willis.png';
import BhachuLogo from '../Images/BHACHU.png';
import CremoGsmLogo from '../Images/CREMO.png';
import PresenterLogo from '../Images/presenter.png';
import PentecostLogo from '../Images/Pentecostal.png';
import ModyLogo from '../Images/mody.png';
import Abaku from '../Images/abaku.png';
import Mudy from '../Images/mudy.png';
import ARUNG from '../Images/ARUNG.png';
import DFM from '../Images/dfm.png';
import US from '../Images/us.png';
import DLS from '../Images/DLS.png';
import ISIDRO from '../Images/ISIDRO.png';
import zoom from '../Images/zoom.png';
import AZ from '../Images/az.png';
import RS from '../Images/RS.png';

export default function LandingPage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('tg-theme') || 'light');

  const [kesToUsdt, setKesToUsdt] = useState(0.00773);
  const [rateLoading, setRateLoading] = useState(true);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('tg-theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'light' ? 'dark' : 'light');

  useEffect(() => {
    fetch('https://api.exchangerate-api.com/v4/latest/KES')
      .then(res => res.json())
      .then(data => {
        const rate = data?.rates?.USD ?? 0.00773;
        setKesToUsdt(rate);
      })
      .catch(() => {})
      .finally(() => setRateLoading(false));
  }, []);

  const toUsdt = (kes) => {
    const val = kes * kesToUsdt;
    return val >= 0.01 ? val.toFixed(2) : val.toFixed(4);
  };

  const resellers = [
    { name: "DevRovince",              region: "Middle East",  verified: true, whatsapp: "254791441451",  website: "https://tigerguardtool.com",                        logo: DevRovinceLogo },
    { name: "RANTECH",                 region: "Kenya",        verified: true, whatsapp: "254100274817",  website: "",                                                  logo: RantechLogo },
    { name: "KINGSLEY0XP",             region: "Uganda",       verified: true, whatsapp: "256779150053",  website: "https://www.kingsley0xpsoftwaresolutions.site",      logo: Kingsley0xpLogo },
    { name: "BRIGHT PHONE REPAIR",     region: "Tanzania",     verified: true, whatsapp: "255742250085",  website: "",                                                  logo: BrightPhoneLogo },
    { name: "FALCON GSM SERVICES",     region: "Uganda",       verified: true, whatsapp: "256787731264",  website: "https://bitzear.store",                             logo: FalconGsmLogo },
    { name: "JONA TEK UG",             region: "Uganda",       verified: true, whatsapp: "256748160100",  website: "https://jonatekgsm.store/",                         logo: JonaTekLogo },
    { name: "Legend@TCH.UG",           region: "Uganda",       verified: true, whatsapp: "256727908399",  website: "",                                                  logo: LegendTchLogo },
    { name: "Mr Presenter Tech",       region: "Tanzania",     verified: true, whatsapp: "255743135110",  website: "",                                                  logo: PresenterLogo },
    { name: "Wizzotech🌐",             region: "Tanzania",     verified: true, whatsapp: "+255629679642", website: "",                                                  logo: WizzotechLogo },
    { name: "KAZURI TECH",             region: "Kenya",        verified: true, whatsapp: "+254100443387", website: "",                                                  logo: KazuriTechLogo },
    { name: "JUDE GADGETS GSM",        region: "Uganda",       verified: true, whatsapp: "+256787237844", website: "",                                                  logo: JudeGadgetsLogo },
    { name: "Expresstelecom2026",      region: "Uganda",       verified: true, whatsapp: "+256779288660", website: "",                                                  logo: PentecostLogo },
    { name: "SHAMBO SOFT SOLUTIONS",   region: "Uganda",       verified: true, whatsapp: "+256200911537", website: "",                                                  logo: ShamboSoftLogo },
    { name: "PHONETECH MASTER",        region: "Kenya",        verified: true, whatsapp: "+254718333784", website: "",                                                  logo: PhonetechMasterLogo },
    { name: "Mrgriffsoftwarefixes.",   region: "Uganda",       verified: true, whatsapp: "+256704188896", website: "",                                                  logo: MrgriffLogo },
    { name: "Willystechub",            region: "Kenya",        verified: true, whatsapp: "+254755987726", website: "",                                                  logo: WillystechubLogo },
    { name: "modystar2209",            region: "Kenya",        verified: true, whatsapp: "+254713645702", website: "",                                                  logo: ModyLogo },
    { name: "BHACHU PHONE SERVICES",   region: "Tanzania",     verified: true, whatsapp: "+255612006292", website: "https://bhachuboy.com",                             logo: BhachuLogo },
    { name: "CREMOGSM",               region: "Malawi",       verified: true, whatsapp: "+265885725451", website: "https://cremogsm.com",                              logo: CremoGsmLogo },
    { name: "Abubakar Ziyech Services",region: "Mozambique",   verified: true, whatsapp: "+258845973313", website: "https://abubakargsmserver.com/",                    logo: Abaku },
    { name: "MUDY-MOBILE-TECH",        region: "South Africa", verified: true, whatsapp: "+27697325476",  website: "https://mudymobile.com/",                           logo: Mudy },
    { name: "Arungsm",                region: "Pakistan",     verified: true, whatsapp: "+923003022164", website: "",                                                  logo: ARUNG },
    { name: "Dfmeditech",             region: "Tanzania",     verified: true, whatsapp: "+255775483722", website: "",                                                  logo: DFM },
    { name: "USTECH",                region: "Burundi",      verified: true, whatsapp: "+25761400965",  website: "https://ustechtechnology.com",                      logo: US },
    { name: "Dlsunlockerserver",                region: "Mozambique",      verified: true, whatsapp: "+258857947977",  website: "https://dlsunlockerserver.site",                      logo: DLS },
    { name: "ISIDRO SERVICES",                region: "Mozambique and worldwide",      verified: true, whatsapp: " +258868215724",  website: "https://isidrogsmboss.site",                      logo: ISIDRO },
    { name: "Zoomtech254.com",                region: "Kenya and worldwide",      verified: true, whatsapp: " +254795540536",  website: "https://zoomtech254.com",                      logo: zoom },
    { name: "Elygn azwere",                region: "Kenya and worldwide",      verified: true, whatsapp: " +254110264401",  website: "",                      logo: AZ },
    { name: "GMS RESELLER",                region: "Qatar",      verified: true, whatsapp: "+97477546061",  website: "https://gmsreseller.com/",                      logo: RS },
  ];

  const rentalTools = [
    { name: "Pandora Tool",          priceKes: 1350, duration: "2 days",      image: PandoraToolImg,    description: "In Stock" },
    { name: "Pandora Tool",          priceKes: 3250, duration: "80+ days",    image: PandoraToolImg,    description: "In Stock" },
    { name: "Unlock Tool",           priceKes: 200,  duration: "6hrs",        image: UnlockToolImg,     description: "In Stock" },
    { name: "VIVO MTK,QCOM",         priceKes: 3185, duration: "1 to 10min",  image: vivo,              description: "Frp reset|DEMO|ID REMOVE|(remote)" },
    { name: "Cm2 Port Sharing",      priceKes: 300,  duration: "2hrs",        image: Cm2PortSharingImg, description: "In Stock" },
    { name: "TFM",                   priceKes: 200,  duration: "2hrs",        image: TfmImg,            description: "In Stock" },
    { name: "Hydra Tool",            priceKes: 350,  duration: "Per Day",     image: HydraImg,          description: "In Stock" },
    { name: "Tiger Guard Tool",      priceKes: 500,  duration: "12hrs",       image: TigerGuardImg,     description: "In Stock" },
    { name: "Android Multi Tool",    priceKes: 200,  duration: "2hrs",        image: AmtImg,            description: "In Stock" },
    { name: "TSM Tool",              priceKes: 200,  duration: "12hrs",       image: TsmImg,            description: "In Stock" },
    { name: "DFT Pro Tool",          priceKes: 450,  duration: "48hrs",       image: DftImg,            description: "In Stock" },
    { name: "MDM Fix Tool",          priceKes: 300,  duration: "6hrs",        image: MdmFixToolImg,     description: "In Stock" },
    { name: "Cheatah Tool",          priceKes: 350,  duration: "12hrs",       image: CheatahImg,        description: "In Stock" },
    { name: "AnonySHU Tool",         priceKes: 500,  duration: "12hrs",       image: Anonyshu,          description: "In Stock" },
    { name: "TR Tool",               priceKes: 400,  duration: "24hrs",       image: TR,                description: "In Stock" },
    { name: "AWT Tool",              priceKes: 350,  duration: "48hrs",       image: Awt,               description: "In Stock" },
    { name: "Griffin Tool",          priceKes: 550,  duration: "6hrs",        image: GFS,               description: "In Stock" },
    { name: "EFT PRO DIGITAL Tool",  priceKes: 550,  duration: "4hrs",        image: EFT,               description: "In Stock" },
    { name: "360 Tool",              priceKes: 400,  duration: "12hrs",       image: THREE60,           description: "In Stock" },
  ];

  const WHATSAPP_NUMBER = "254791441451";

  const getRentalWhatsAppLink = (toolName, priceKes, duration) => {
    const message = encodeURIComponent(
      `Hello! I'm interested in renting the *${toolName}* at KES ${priceKes.toLocaleString()} (≈ ${toUsdt(priceKes)} USDT) / ${duration}. Please share availability details.`
    );
    return `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;
  };

  const scrollRentals = (dir) => {
    const el = document.getElementById('rentals-grid');
    if (el) el.scrollBy({ left: dir * 340, behavior: 'smooth' });
  };

  return (
    <div className="landing-page">

      {/* ── HEADER ── */}
      <header className="landing-header">
        <div className="container">
          <div className="logo">
            <span className="logo-icon">🐯</span>
            <span className="logo-text">Tiger Guard</span>
          </div>

          <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
            <a href="#features"     onClick={() => setMenuOpen(false)}>Features</a>
            <a href="#download"     onClick={() => setMenuOpen(false)}>Download</a>
            <a href="#resellers"    onClick={() => setMenuOpen(false)}>Resellers</a>
            <a href="#tool-rentals" onClick={() => setMenuOpen(false)}>Tool Rentals</a>
            <a href="#pricing"      onClick={() => setMenuOpen(false)}>Pricing</a>
            <a href="#contact"      onClick={() => setMenuOpen(false)}>Contact</a>
            <button onClick={() => navigate('/login')} className="btn-login">Login</button>
          </nav>

          <div className="header-right">
            <button
              className="theme-toggle"
              onClick={toggleTheme}
              aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
              title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
            >
              <span className="theme-toggle-thumb">
                {theme === 'light' ? '☀️' : '🌙'}
              </span>
            </button>
            <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
              {menuOpen ? '✕' : '☰'}
            </button>
          </div>
        </div>
      </header>

      {/* ── HERO ── */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">🏆 #1 Professional Servicing Tool</div>
            <h1 className="hero-title">
              The Most Trusted <br/>
              <span className="gradient-text">Device Servicing Solution</span>
            </h1>
            <p className="hero-subtitle">
              Industry-leading device servicing tool trusted by thousands of technicians worldwide.
              Fast, secure, and reliable servicing for all major brands and models.
            </p>
            <div className="hero-buttons">
              <button onClick={() => navigate('/login')} className="btn-primary-large">Get Started</button>
              <a href="https://wa.me/254791441451?text=Hello%2C%20I%27m%20interested%20in%20Tiger%20Guard%20unlocking%20tool"
                target="_blank" rel="noopener noreferrer" className="btn-whatsapp-large">
                <span className="whatsapp-icon">📱</span> WhatsApp Us
              </a>
            </div>
          </div>
          <div className="hero-image">
            <div className="floating-card">
              <div className="card-header">
                <span className="status-dot"></span>
                <span>Servicing Active</span>
              </div>
              <div className="card-body">
                <div className="stat">
                  <span className="stat-icon">📱</span>
                  <span className="stat-value">750k+</span>
                  <span className="stat-label">Devices Serviced</span>
                </div>
                <div className="stat">
                  <span className="stat-icon">⚡</span>
                  <span className="stat-value">97.3%</span>
                  <span className="stat-label">Success Rate</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── FEATURES ── */}
      <section id="features" className="features">
        <div className="container">
          <h2 className="section-title">Why Choose Tiger Guard</h2>
          <p className="section-subtitle">The most powerful unlocking tool in the industry</p>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🔓</div>
              <h3>Universal Unlocking</h3>
              <p>Support for all major brands: Samsung, Tecno, Infinix, Itel and more</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Lightning Fast</h3>
              <p>Quick unlocking process with high success rates. Most devices unlocked in minutes.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>100% Safe</h3>
              <p>No data loss, no damage to device. Secure unlocking with advanced algorithms.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏪</div>
              <h3>Reseller Network</h3>
              <p>Join our global network of authorized resellers and grow your business.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Flexible Pricing</h3>
              <p>Pay as you go with hourly, monthly, or yearly plans. No hidden fees.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📞</div>
              <h3>24/7 Support</h3>
              <p>Expert technical support available round the clock via WhatsApp and email.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── DOWNLOAD ── */}
      <section id="download" className="download-section">
        <div className="container">
          <h2 className="section-title">Download Tiger Guard Pro</h2>
          <p className="section-subtitle">Choose your preferred mirror to download v1.1.6</p>
          <div className="download-cards">

            <a
              href="https://www.mediafire.com/file/np0vszntmp1jzfx/TigerGuardPro_V1.1.5.exe/file"
              target="_blank"
              rel="noopener noreferrer"
              className="download-card"
            >
              <div className="download-card-icon">📦</div>
              <div className="download-card-body">
                <h3>MediaFire</h3>
                <p>Hosted on MediaFire CDN. Click to open the download page.</p>
                <span className="download-card-tag">Opens download page</span>
              </div>
              <div className="download-card-arrow">→</div>
            </a>

            <a
              href="https://drive.google.com/file/d/17UbE3fF5v7a5tEF-V7_Tf1k4G_LhOJYY/view"
              className="download-card download-card-featured"
            >
              <div className="download-card-icon">☁️</div>
              <div className="download-card-body">
                <h3>Google Drive</h3>
                <p>Hosted on Google Drive. File downloads directly to your device.</p>
                <span className="download-card-tag download-card-tag-direct">⚡ Direct download</span>
              </div>
              <div className="download-card-arrow">→</div>
            </a>

          </div>
          <p className="download-note">🔒 TigerGuardPro V1.1.6 · RAR archive · Always download from official mirrors only</p>
        </div>
      </section>

      {/* ── RESELLERS ── */}
      <section id="resellers" className="resellers">
        <div className="container">
          <h2 className="section-title">Authorized Resellers</h2>
          <p className="section-subtitle">Our trusted partners worldwide</p>
          <div className="resellers-scroll-wrapper">
            <button className="scroll-btn left" onClick={() => {
              const el = document.getElementById('resellers-grid');
              if (el) el.scrollBy({ left: -300, behavior: 'smooth' });
            }} aria-label="Scroll left">&#8249;</button>
            <div className="resellers-grid" id="resellers-grid">
              {resellers.map((reseller, index) => (
                <div key={index} className="reseller-card">
                  <div className="reseller-logo-wrap">
                    <img src={reseller.logo} alt={`${reseller.name} logo`} className="reseller-logo" />
                  </div>
                  <div className="reseller-header">
                    <h3>{reseller.name}</h3>
                    {reseller.verified && <span className="verified-badge">✓ Verified</span>}
                  </div>
                  <p className="reseller-region">📍 {reseller.region}</p>
                  {reseller.website && (
                    <a href={reseller.website} target="_blank" rel="noopener noreferrer" className="reseller-website-link">
                      🌐 Visit Website
                    </a>
                  )}
                  <a
                    href={`https://wa.me/${reseller.whatsapp}?text=Hello%20I'm%20interested%20in%20Tiger%20Guard`}
                    target="_blank" rel="noopener noreferrer"
                    className="btn-whatsapp-large"
                  >
                    <span className="whatsapp-icon">📱</span> WhatsApp
                  </a>
                </div>
              ))}
            </div>
            <button className="scroll-btn right" onClick={() => {
              const el = document.getElementById('resellers-grid');
              if (el) el.scrollBy({ left: 300, behavior: 'smooth' });
            }} aria-label="Scroll right">&#8250;</button>
          </div>
        </div>
      </section>

      {/* ── TOOL RENTALS ── */}
      <section id="tool-rentals" className="tool-rentals">
        <div className="container">
          <h2 className="section-title">Tool Rentals</h2>
          <p className="section-subtitle">Rent professional tools at affordable rates — contact us via WhatsApp to book</p>
          <div className="rentals-scroll-wrapper">
            <button className="scroll-btn left" onClick={() => scrollRentals(-1)} aria-label="Scroll left">&#8249;</button>
            <div className="rentals-grid" id="rentals-grid">
              {rentalTools.map((tool, index) => (
                <div key={index} className="rental-card">
                  <div className="rental-image-wrap">
                    <img src={tool.image} alt={tool.name} className="rental-image" />
                    <span className="rental-duration-badge">{tool.duration}</span>
                  </div>
                  <div className="rental-body">
                    <h3 className="rental-name">{tool.name}</h3>
                    <p className="rental-description">{tool.description}</p>
                    <div className="rental-price-row">
                      <div className="rental-price-primary">
                        <span className="rental-price">KES {tool.priceKes.toLocaleString()}</span>
                        <span className="rental-per">/ {tool.duration}</span>
                      </div>
                      <div className="rental-price-usdt">
                        {rateLoading ? (
                          <span className="usdt-loading">...</span>
                        ) : (
                          <span className="usdt-badge">≈ {toUsdt(tool.priceKes)} USDT</span>
                        )}
                      </div>
                    </div>
                    <a
                      href={getRentalWhatsAppLink(tool.name, tool.priceKes, tool.duration)}
                      target="_blank" rel="noopener noreferrer"
                      className="btn-whatsapp-large rental-whatsapp-btn"
                    >
                      <span className="whatsapp-icon">📱</span> Rent via WhatsApp
                    </a>
                  </div>
                </div>
              ))}
            </div>
            <button className="scroll-btn right" onClick={() => scrollRentals(1)} aria-label="Scroll right">&#8250;</button>
          </div>
        </div>
      </section>

      {/* ── PRICING ── */}
      <section id="pricing" className="pricing">
        <div className="container">
          <h2 className="section-title">Flexible Pricing Plans</h2>
          <p className="section-subtitle">Choose the plan that fits your needs</p>
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>12 Hours</h3>
                <div className="price"><span className="currency">$</span><span className="amount">4</span></div>
              </div>
              <ul className="pricing-features">
                <li>✓ 12 hour access</li>
                <li>✓ All unlocking features</li>
                <li>✓ Machine binding</li>
                <li>✓ Email support</li>
              </ul>
            </div>
            <div className="pricing-card featured">
              <div className="badge">Most Popular</div>
              <div className="pricing-header">
                <h3>3 Months</h3>
                <div className="price"><span className="currency">$</span><span className="amount">20</span></div>
              </div>
              <ul className="pricing-features">
                <li>✓ 90 days access</li>
                <li>✓ All unlocking features</li>
                <li>✓ Machine binding</li>
                <li>✓ Priority support</li>
                <li>✓ Free updates</li>
              </ul>
            </div>
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>6 Months</h3>
                <div className="price"><span className="currency">$</span><span className="amount">35</span></div>
              </div>
              <ul className="pricing-features">
                <li>✓ 180 days access</li>
                <li>✓ All unlocking features</li>
                <li>✓ Machine binding</li>
                <li>✓ Priority support</li>
                <li>✓ Free updates</li>
              </ul>
            </div>
            <div className="pricing-card">
              <div className="pricing-header">
                <h3>1 Year</h3>
                <div className="price"><span className="currency">$</span><span className="amount">45</span></div>
              </div>
              <ul className="pricing-features">
                <li>✓ 365 days access</li>
                <li>✓ All unlocking features</li>
                <li>✓ Machine binding</li>
                <li>✓ Premium support</li>
                <li>✓ Free updates</li>
                <li>✓ Reseller discount</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT ── */}
      <section id="contact" className="contact">
        <div className="container">
          <div className="contact-content">
            <div className="contact-info">
              <h2 className="section-title">Get in Touch</h2>
              <p>Have questions? Need support? We're here to help!</p>
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="contact-icon">✉️</div>
                  <h3>Email Support</h3>
                  <p>Technical assistance</p>
                  <a href="mailto:support@tigerguard.com" className="contact-link">support@tigerguard.com</a>
                </div>
                <div className="contact-method">
                  <div className="contact-icon">⏰</div>
                  <h3>Support Hours</h3>
                  <p>24/7 availability</p>
                  <span className="contact-link">Always Online</span>
                </div>
              </div>
            </div>
            <div className="contact-cta">
              <h3>Ready to unlock?</h3>
              <p>Start using the #1 unlocking tool today</p>
              <div className="cta-buttons">
                <button onClick={() => navigate('/login')} className="btn-primary-large">Login Now</button>
                <a href="https://wa.me/254791441451?text=Hello%2C%20I%27m%20interested%20in%20Tiger%20Guard"
                  target="_blank" rel="noopener noreferrer" className="btn-whatsapp-large">
                  <span className="whatsapp-icon">📱</span> Chat on WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer variant="admin" />
    </div>
  );
}